import { Col, Table } from "reactstrap";
import { H3 } from "../../../../../../../AbstractElements";
import { CurrentCartTitle } from "../../../../../../../Constants/Constants";
import CurrentCartTableBody from "./CurrentCartTableBody";
import { CurrentCartTableFooterData } from "../../../../../../../Data/Forms&Table/Forms/FormLayout";

const CurrentCart = () => {
  return (
    <Col xl="4">
      <div className="shipping-info">
        <H3>{CurrentCartTitle}</H3>
        <div className="overflow-auto custom-scrollbar">
          <Table striped>
            <thead>
              <tr>
                <th scope="col">{"Product"}</th>
                <th scope="col">{"Product Detail"}</th>
                <th scope="col">{"Price"}</th>
              </tr>
            </thead>
            <CurrentCartTableBody />
            <tfoot>
              {CurrentCartTableFooterData.map((data, index) => (
                <tr key={index}>
                  <td>{data.footerTittle}</td>
                  <td colSpan={2}>{"$"}{data.price}</td>
                </tr>
              ))}
            </tfoot>
          </Table>
        </div>
      </div>
    </Col>
  );
};

export default CurrentCart;
